import { __decorate } from "tslib";
import { handleError } from '@blade/common/utils/handle-error';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    imgSrc;
    supportFormat;
    pixel;
    ratio;
    maxSize;
    imgSrc1 = '';
    nodeRatio = 1;
    fileRatio = 1;
    onImgSrc(newVal) {
        this.imgSrc1 = newVal;
    }
    mounted() {
        const rootNode = this.$refs.root.getBoundingClientRect();
        this.nodeRatio = rootNode.width / rootNode.height;
    }
    updated() {
        if (this.imgSrc1) {
            this.$refs.background.setAttribute('style', `
          ${this.fileRatio < this.nodeRatio ? 'height: 100%;' : 'width: 100%;'}
        `);
        }
    }
    fileDragover(e) {
        e.preventDefault();
    }
    fileDrop(e) {
        e.preventDefault();
        const file = e.dataTransfer.files[0]; // 获取到第一个上传的文件对象
        this.handleFileChange(file);
    }
    async handleFileChange(e) {
        try {
            const file = e.target ? e.target.files[0] : e;
            if (!file)
                return;
            if (e.target) {
                e.target.value = '';
            }
            const name = file.name;
            const format = name.substring(name.lastIndexOf('.') + 1).toLowerCase();
            if (!this.supportFormat.includes(format)) {
                throw new Error('formatError');
            }
            const img = (await this.convertBase64(file));
            const imgOri = await this.imageLoad(img);
            if (!imgOri)
                throw new Error('formatError');
            const height = imgOri?.height;
            const width = imgOri?.width;
            const isPixelFit = height <= this.pixel.maxHeight && width <= this.pixel.maxWidth && width >= this.pixel.minWidth && height >= this.pixel.minHeight;
            const fileSize = (img.length / 4) * 3;
            let isRatioFit = true;
            if (this.ratio) {
                isRatioFit = height * this.ratio === width;
            }
            else {
                this.fileRatio = width / height;
            }
            if (isPixelFit && fileSize < this.maxSize && isRatioFit) {
                this.$emit('onbase64', img, format);
            }
            else {
                throw new Error('formatError');
            }
        }
        catch (err) {
            if (err.message === 'formatError') {
                this.$message.error(this.$t('formatError').toString());
            }
            else {
                handleError(err);
            }
        }
    }
    convertBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (e) => reject(e);
        });
    }
    imageLoad = (url) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                resolve(img);
            };
            img.onerror = function () {
                resolve(false);
            };
            img.src = url;
        });
    };
};
__decorate([
    Prop({ default: '' })
], default_1.prototype, "imgSrc", void 0);
__decorate([
    Prop({ default: () => ['jpeg', 'jpg', 'png'] })
], default_1.prototype, "supportFormat", void 0);
__decorate([
    Prop({
        default: () => {
            return {
                minWidth: 0,
                maxWidth: Infinity,
                minHeight: 0,
                maxHeight: Infinity,
            };
        },
    })
], default_1.prototype, "pixel", void 0);
__decorate([
    Prop({ default: 0 })
], default_1.prototype, "ratio", void 0);
__decorate([
    Prop({ default: Infinity })
], default_1.prototype, "maxSize", void 0);
__decorate([
    Watch('imgSrc')
], default_1.prototype, "onImgSrc", null);
default_1 = __decorate([
    Component({
        name: 'ImageEdit',
        components: {},
        i18n: {
            messages: {
                'en-us': {
                    formatError: 'The file format is invalid',
                    upload: 'Click or drag to upload',
                    supportType: 'Support Type',
                    uploadCompleted: 'Upload successfully',
                },
                zh: {
                    formatError: '文件格式不符合要求',
                    upload: '点击或拖拽上传',
                    supportType: '支持格式',
                    uploadCompleted: '上传成功',
                },
            },
        },
    })
], default_1);
export default default_1;
